module.exports = __webpack_public_path__ + "static/img/3.c3396254.png";